// Riskified
// Its requirement is determinable only after the offers are loaded
// Loads in page Load
// Sets current page on page change
// Sends the session id on booking request

import loadScript from '@daedalus/core/src/utils/network/loadScript'
import {v4 as uuid} from 'uuid'

enum DependencyStatus {
  NOT_LOADED,
  LOADED,
  LOADING
}

let dependencyStatus = DependencyStatus.NOT_LOADED
let sessionId: string

type RiskifiedReturnType = {
  pageView: (page) => void
  sessionId: string
}

type RiskifiedType = (config: {
  storeDomain: string
}) => Promise<RiskifiedReturnType>

const Riskified: RiskifiedType = async config => {
  if (!sessionId) sessionId = uuid()

  console.log('Riskified::sessionId', sessionId)
  const loadDependencies = async (): Promise<unknown> => {
    if (
      dependencyStatus === DependencyStatus.LOADED ||
      dependencyStatus === DependencyStatus.LOADING
    )
      return true

    dependencyStatus = DependencyStatus.LOADING
    const url =
      (document.location.protocol == 'https:' ? 'https://' : 'http://') +
      'beacon.riskified.com?shop=' +
      config.storeDomain +
      '&sid=' +
      sessionId
    return loadScript(url, {async: true})
  }

  const init = async () => {
    return loadDependencies().then(() => {
      dependencyStatus = DependencyStatus.LOADED
      return apiObject
    })
  }

  const pageView = (page: string) => {
    try {
      // TODO: Disabled for enforcing lint, fix if possible
      // eslint-disable-next-line no-undef
      RISKX.go(page)
    } catch {
      console.log('Error calling RISK.go')
    }
  }

  const apiObject = {
    pageView,
    sessionId
  }

  return init()
}

export const getRiskifiedSessionId = () => sessionId

export default Riskified
